import { RootState } from '../../types';

const all = (state: RootState) => state.auth.passwordUpdate;
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
